import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { FunctionComponent, PropsWithChildren, useMemo } from 'react';
import { useSession, signIn } from 'next-auth/react';
import { ApolloProvider } from '@apollo/client';
import MainLayout from '@layouts/main';

export const createApolloClient = (token?: string) => {
  const headers: Record<string, string> =
    token == null ? {} : { authorization: `Bearer ${token}` };
  return new ApolloClient({
    link: new HttpLink({
      uri: `${process.env.NEXT_PUBLIC_API_BASE}/graphql`,
      credentials: 'same-origin',
      headers,
    }),
    cache: new InMemoryCache({
      typePolicies: {
        Person: {
          keyFields: ['darn'],
        },
      },
    }),
  });
};

export const ApolloProviderWrapper: FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  const { data: session, status } = useSession();

  const apolloClient = useMemo(
    () => createApolloClient(session?.accessToken),
    [session?.accessToken]
  );

  if (status === 'unauthenticated') {
    void signIn('da');
  }
  if (status !== 'authenticated') {
    return <MainLayout alignment="top" panelled={false} showSpinner />;
  }
  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};
